export const baseApi = process.env.REACT_APP_BASE_API || "http://localhost:8080/api";

export const redirectToMicrosoftSSO = (queryParams = "") => {
	const redirectUrl = `${baseApi}/auth/microsoft${queryParams}`;
	window.location.assign(redirectUrl);
};
